<template>
  <InputBase
    v-model="localValue"
    :error="error"
    type="date"
    placeholder="mm/dd/yyyy"
  />
</template>

<script setup>
import { computed } from 'vue'
import InputBase from './InputBase.vue'

const props = defineProps({
  modelValue: String,
  error: String,
})

const emit = defineEmits(['update:modelValue'])

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
